var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1543 15.7715C8.1543 14.7737 8.96313 13.9648 9.96094 13.9648C10.9587 13.9648 11.7676 14.7737 11.7676 15.7715C11.7676 16.4102 11.4359 16.9709 10.9357 17.2922V19.4336C10.9357 19.9729 10.4984 20.4102 9.95913 20.4102C9.41978 20.4102 8.98257 19.9729 8.98257 19.4336V17.2899C8.48438 16.9683 8.1543 16.4086 8.1543 15.7715Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2326 9.17969H16.9922C18.6076 9.17969 19.9219 10.4939 19.9219 12.1094V22.0703C19.9219 23.6857 18.6076 25 16.9922 25H2.92969C1.31426 25 0 23.6857 0 22.0703V12.1094C0 10.4939 1.31426 9.17969 2.92969 9.17969H4.68569V5.16455C4.68569 2.3168 7.05137 0 9.95913 0C12.8669 0 15.2326 2.3168 15.2326 5.16455V9.17969ZM9.95913 1.95312C8.12832 1.95312 6.63882 3.39375 6.63882 5.16455V9.17969H13.2794V5.16455C13.2794 3.39375 11.7899 1.95312 9.95913 1.95312ZM16.9922 23.0469C17.5307 23.0469 17.9688 22.6088 17.9688 22.0703V12.1094C17.9688 11.5709 17.5307 11.1328 16.9922 11.1328H2.92969C2.39121 11.1328 1.95312 11.5709 1.95312 12.1094V22.0703C1.95312 22.6088 2.39121 23.0469 2.92969 23.0469H16.9922Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.fa93bc72cd1c52df66260a545a95e444.svg";
export { ForwardRef as ReactComponent };